module.exports = __webpack_public_path__ + "static/media/Whatsapp.dd43ecae.svg";